module.exports = __webpack_public_path__ + "img/Partners15.96b0036c.png";